class DeskmithContactForm extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.topic = this.querySelector('[data-contact-topic]');
    this.orderField = this.querySelector('[data-contact-order]');
    this.hint = this.querySelector('[data-contact-hint]');
    if (!this.topic || !this.orderField || !this.hint) return;

    if (!this.initialized) {
      const requestedTopic = new URLSearchParams(window.location.search).get('topic');
      // Explicit server selections and restored customer choices take precedence.
      if (requestedTopic === 'business' && this.topic.value === 'Product advice' && !this.topic.querySelector('option[selected]')) {
        const businessOption = Array.from(this.topic.options).find(option => option.value === 'Business inquiry');
        if (businessOption) {
          businessOption.defaultSelected = true;
          this.topic.value = businessOption.value;
        }
      }
      this.initialized = true;
    }

    this.topic.addEventListener('change', () => this.updateTopic(), { signal: this.controller.signal });
    this.closest('form')?.addEventListener('reset', () => {
      requestAnimationFrame(() => this.updateTopic());
    }, { signal: this.controller.signal });
    window.addEventListener('pageshow', () => this.updateTopic(), { signal: this.controller.signal });
    this.updateTopic();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  updateTopic() {
    const topic = this.topic.value;
    const needsOrder = topic === 'Order support' || topic === 'Warranty';
    this.orderField.hidden = !needsOrder;
    this.orderField.querySelector('input').disabled = !needsOrder;
    const hints = {
      'Product advice': 'Include the product name and what you would like to know.',
      'Order support': 'Tell us which item or delivery you need help with and what happened.',
      'Warranty': 'Include the product name, a description of the issue and when it started.',
      'Business inquiry': 'Include the products, quantity, delivery location and target date for your project.',
    };
    this.hint.textContent = hints[topic] || hints['Product advice'];
  }
}

if (!customElements.get('deskmith-contact-form')) {
  customElements.define('deskmith-contact-form', DeskmithContactForm);
}
